import "./job.css";
import React, { useState } from 'react';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import MailOutline from '@material-ui/icons/MailOutline';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import ShoppingBasketOutlined from '@material-ui/icons/ShoppingBasketOutlined';
import SchoolOutlined from '@material-ui/icons/SchoolOutlined';
import benefit from '../../img/corporate_benefit.png';


export default function Corporatebenefit()
 {  

    return    (
    <div id="wrapper">
        <div className="section_title">Corporate Benefits</div>
      <div style={{
         padding: "20px 20px",
         color: "#55ba5e",
         // fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}>
          <h2 className='angebote'> Attraktive und exklusive Angebote sowie viele Nachlässe</h2>
       <span style={{color:"#000000",fontSize:"14px"}}>
          
     <p> Alle unsere Mitarbeiter sind herzlich eingeladen Gutscheine und Rabatte von mehr als 800 nahmhaften Anbietern in Deutchland für sich zu nutzen!</p>

<img className='benefit' src={benefit}/>


<h1>Procuratio</h1>
<p> Nähere informationen im nachstehnden Info-Flyer.</p>
<p> Registrierungscode: #pro%CB21+</p>
<a className='underline' href="https://procuratio.mitarbeiterangebote.de" target="_blank">procuratio.mitarbeiterangebote.de</a><br></br><br></br>


 
<a className='a-link-info' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/Ankuendigung_procuratio.mitarbeiterangebote.de_DEU.pdf"> ↔️  Info deutsch</a><br></br>
<a  className='a-link-info' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/Ankuendigung_procuratio.mitarbeiterangebote.de_ENG.pdf">↔️  Info englisch</a>

<h1>Procommendo</h1>
<p> Nähere informationen im nachstehnden Info-Flyer</p>
<p> Registrierungscode: #pro%CB21+</p>
<a className='underline' traget="_blank" href="https://procommendo.mitarbeiterangebote.de" target="_blank">procommendo.mitarbeiterangebote.de</a><br></br><br></br>


 
<a className='a-link' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/Ankuendigung_procommendo.mitarbeiterangebote.de_DEU.pdf"> ↔️ Infoflyer deutsch</a><br></br>
<a  className='a-link' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/Ankuendigung_procommendo.mitarbeiterangebote.de_ENG.pdf"> ↔️ Infoflyer englisch</a>


</span>
       </div>
    </div>
    )

 }

